import { render, staticRenderFns } from "./threSholddialog.vue?vue&type=template&id=1ad61124&scoped=true"
import script from "./threSholddialog.vue?vue&type=script&lang=js"
export * from "./threSholddialog.vue?vue&type=script&lang=js"
import style0 from "./threSholddialog.vue?vue&type=style&index=0&id=1ad61124&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/ad/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ad61124",
  null
  
)

export default component.exports